/**
 * Navmenu plugin for header responsive navigation.
 * @param {jQuery Object} element
 * @param {Object} options
 *
 * Registered events:
 * ac.navmenu.show
 * ac.navmenu.hide
 *
 */
var navmenu = function(element, options) {

    var _defaults = {
        namespace: 'navmenu',
        activeClass: 'is-active',
        menuListSelector: '.navmenu-list',
        menuToggleSelector: '.navmenu-toggle'
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});
    widget.element = element;
    widget.menuList = $(widget.options.menuListSelector, element);
    widget.menuLinks = $('a', widget.menuList);
    widget.menuToggle = $(widget.options.menuToggleSelector, element);
    widget.menuWrapper = $('> li', element);

    widget._init();
    widget._bindClickEvents();
    widget._bindPluginEvents();
};

/**
 * Initialize method.
 * Add accessible attributes to plugin elements.
 */
navmenu.prototype._init = function() {
    var widget = this;

    widget.element.attr('aria-haspopup', true);
    widget.menuWrapper.attr({
        'role': 'menuitem',
        'aria-haspopup': true
    });

    widget.hide();
};

/**
 * Show method.
 */
navmenu.prototype.show = function() {
    var widget = this;

    if (widget.element.hasClass(widget.options.activeClass)) return;

    widget._closeOpenedMenus();
    widget._bindClickOnBodyClose();

    widget.element.addClass(widget.options.activeClass);
    widget.menuList.addClass('slideDownIn');

    widget.element.attr('aria-expanded', true);
    widget.menuWrapper.attr('aria-expanded', true);
    widget.menuLinks.attr('tabindex', '0');

    widget.element.trigger(widget.options.namespace + '.opened');
};

/**
 * Hide method.
 */
navmenu.prototype.hide = function() {
    var widget = this;
    var wasActive = widget.element.hasClass(widget.options.activeClass);

    if (wasActive) {
        widget.element.removeClass(widget.options.activeClass);
        widget.menuList.removeClass('slideDownIn');
    }

    widget.element.attr('aria-expanded', false);
    widget.menuWrapper.attr('aria-expanded', false);
    widget.menuLinks.attr('tabindex', '-1');

    if (wasActive) {
        widget.element.trigger(widget.options.namespace + '.closed');
    }
};

/**
 * Bind interaction events (click for mobile, hover for desktop).
 */
navmenu.prototype._bindClickEvents = function() {
    var widget = this;
    var ns = widget.options.namespace;
    var xlargeQuery = window.matchMedia('(min-width: 75em)');

    // Click/Enter toggle
    widget.menuToggle
    .off('click.' + ns + ' keydown.' + ns)
    .on('click.' + ns, function(e) {
        $(document).trigger('ac.navmenu.toggle');
        e.stopPropagation();
        if (widget.element.hasClass(widget.options.activeClass)) {
            widget.hide();
        } else {
            widget.show();
        }
    })
    .on('keydown.' + ns, function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            widget.menuToggle.trigger('click');
        }
        if ((e.key === 'ArrowDown' || (e.key === 'Tab' && !e.shiftKey)) && widget.element.hasClass(widget.options.activeClass)) {
            e.preventDefault();
            widget.menuList.find('a').first().focus();
        }
    });

    // Desktop: hover, focus, keyboard
    widget.element
    .off('mouseenter.' + ns + ' mouseleave.' + ns + ' focusin.' + ns + ' focusout.' + ns + ' keydown.' + ns)
    .on('mouseenter.' + ns, function() {
        if (xlargeQuery.matches) widget.show();
    })
    .on('mouseleave.' + ns, function() {
        if (xlargeQuery.matches) widget.hide();
    })
    .on('focusin.' + ns, function() {
        if (xlargeQuery.matches && !widget._escapeClosed) widget.show();
    })
    .on('focusout.' + ns, function(e) {
        if (xlargeQuery.matches && !widget.element[0].contains(e.relatedTarget)) {
            widget.hide();
        }
    });

    // Escape closes menu and prevents focusin from reopening
    var escapeClose = function() {
        widget._escapeClosed = true;
        widget.hide();
        widget.menuToggle.focus();
        setTimeout(function() { widget._escapeClosed = false; }, 0);
    };

    $(document).off('keydown.' + ns + '.escape').on('keydown.' + ns + '.escape', function(e) {
        if (e.key === 'Escape' && widget.element.hasClass(widget.options.activeClass)) {
            escapeClose();
        }
    });

    widget.menuList.off('keydown.' + ns).on('keydown.' + ns, function(e) {
        if (e.key === 'Escape') escapeClose();
    });
};

/**
 * Bind Plugin custom events.
 */
navmenu.prototype._bindPluginEvents = function() {
    var widget = this;

    widget.element.on({
        'ac.navmenu.open': widget.show.bind(widget),
        'ac.navmenu.close': widget.hide.bind(widget)
    });
};

/**
 * Close all other opened navmenu instances.
 */
navmenu.prototype._closeOpenedMenus = function() {
    $('.navmenu').trigger('ac.navmenu.close');
};

/**
 * Close menu when clicking outside the plugin element.
 */
navmenu.prototype._bindClickOnBodyClose = function() {
    var widget = this;
    var ns = widget.options.namespace;
    var body = $(document.body).not(widget.element);

    body
    .off('click.' + ns)
    .on('click.' + ns, function(e) {
        if (widget.element.is($(e.target)) || widget.element.find($(e.target)).length) {
            return;
        }
        widget.hide();
        body.off('click.' + ns);
    });
};


// ---------------------------------------------------------------------------
// Static methods for selector dropdowns (spaces, locations)
// ---------------------------------------------------------------------------

var selectorDropdownsInitialized = false;

/**
 * Helper: toggle a dropdown's open/close state with animation.
 */
function toggleDropdownState(dropdown, isActive) {
    dropdown.classList.toggle('active', isActive);
    dropdown.classList.toggle('slideDownIn', isActive);
}


/**
 * Initialize all selector dropdowns (desktop and mobile).
 * Call once after DOM is ready.
 */
navmenu.initSelectorDropdowns = function() {
    if (selectorDropdownsInitialized) return;
    selectorDropdownsInitialized = true;

    // --- Desktop: hover to show dropdown, click to navigate ---
    document.querySelectorAll('.navmenu-selector-item').forEach(function(item) {
        var dropdownBox = item.querySelector('.dropdown-box');
        var arrow = item.querySelector('.arrow-icon-circle i');
        if (!dropdownBox || !arrow) return;

        var setOpen = function(isActive) {
            toggleDropdownState(dropdownBox, isActive);
            arrow.style.transform = isActive ? 'rotate(180deg)' : '';
        };

        item.addEventListener('mouseenter', function() { setOpen(true); });
        item.addEventListener('mouseleave', function() { setOpen(false); });
        item.addEventListener('focusin', function() { setOpen(true); });
        item.addEventListener('focusout', function(e) {
            if (!item.contains(e.relatedTarget)) setOpen(false);
        });
        item.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') setOpen(false);
        });

        // Click navigates to the selector's target page
        item.addEventListener('click', function(e) {
            if (e.target.closest('.dropdown-box')) return;
            var href = item.dataset.href;
            if (href) window.location.href = href;
        });

        // Click on item-container submits its form
        item.querySelectorAll('.item-container').forEach(function(container) {
            var form = container.querySelector('form');
            if (form) {
                container.addEventListener('click', function() {
                    if (form.requestSubmit) {
                        form.requestSubmit();
                    } else {
                        form.submit();
                    }
                });
            }
        });
    });

    // --- Mobile: tap to toggle dropdown ---
    var mobileItems = document.querySelectorAll('.mobile-selector-item');

    var closeAllMobile = function() {
        mobileItems.forEach(function(item) {
            var toggle = item.querySelector('.mobile-selector-toggle');
            var dropdown = item.querySelector('.mobile-selector-dropdown');
            if (!toggle || !dropdown) return;
            item.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            dropdown.setAttribute('aria-hidden', 'true');
            dropdown.classList.remove('slideDownIn');
        });
    };

    mobileItems.forEach(function(item) {
        var toggle = item.querySelector('.mobile-selector-toggle');
        var dropdown = item.querySelector('.mobile-selector-dropdown');
        if (!toggle || !dropdown) return;

        toggle.addEventListener('click', function(event) {
            event.preventDefault();
            var isOpen = item.classList.contains('is-open');
            closeAllMobile();
            if (!isOpen) {
                item.classList.add('is-open');
                toggle.setAttribute('aria-expanded', 'true');
                dropdown.setAttribute('aria-hidden', 'false');
                dropdown.classList.add('slideDownIn');
            }
        });
    });

    // Close mobile dropdowns on outside click or Escape
    document.addEventListener('click', function(event) {
        if (!event.target.closest('.mobile-navigation-selectors')) {
            closeAllMobile();
        }
    });
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') closeAllMobile();
    });
    $(document)
        .off('ac.navmenu.toggle')
        .on('ac.navmenu.toggle', closeAllMobile);
};

export default navmenu;